console.log('🚀 GM Sentiment Analytics Store: Initializing sentiment analytics module...');

const sentimentAnalytics = {
  namespaced: true,

  state: {
    sentimentData: {},
    emotionData: {},
    trendData: {},
    isLoading: false,
    error: null
  },

  mutations: {
    SET_SENTIMENT_DATA(state, data) {
      console.log('😊 GM Sentiment Analytics: Setting sentiment data:', data);
      state.sentimentData = data;
    },

    SET_EMOTION_DATA(state, data) {
      console.log('😊 GM Sentiment Analytics: Setting emotion data:', data);
      state.emotionData = data;
    },

    SET_TREND_DATA(state, data) {
      console.log('😊 GM Sentiment Analytics: Setting trend data:', data);
      state.trendData = data;
    },

    SET_LOADING(state, isLoading) {
      console.log('🔄 GM Sentiment Analytics: Setting loading state:', isLoading);
      state.isLoading = isLoading;
    },

    SET_ERROR(state, error) {
      console.log('❌ GM Sentiment Analytics: Setting error:', error);
      state.error = error;
    },

    CLEAR_ERROR(state) {
      console.log('✅ GM Sentiment Analytics: Clearing error');
      state.error = null;
    }
  },

  actions: {
    async fetchSentimentData({ commit }, filters = {}) {
      try {
        console.log('😊 GM Sentiment Analytics: Fetching sentiment data...');
        commit('SET_LOADING', true);
        commit('CLEAR_ERROR');

        const queryParams = new URLSearchParams(filters);
        const response = await fetch(`/api/v1/accounts/gm_analytics/sentiment_analytics?${queryParams}`, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]')?.getAttribute('content')
          }
        });

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        const result = await response.json();
        console.log('✅ GM Sentiment Analytics: Sentiment data fetched successfully:', result);

        if (result.success) {
          commit('SET_SENTIMENT_DATA', result.data);
        } else {
          throw new Error(result.error || 'Failed to fetch sentiment data');
        }

        return result;
      } catch (error) {
        console.error('❌ GM Sentiment Analytics: Error fetching sentiment data:', error);
        commit('SET_ERROR', error.message);
        throw error;
      } finally {
        commit('SET_LOADING', false);
      }
    }
  },

  getters: {
    sentimentData: (state) => state.sentimentData,
    emotionData: (state) => state.emotionData,
    trendData: (state) => state.trendData,
    isLoading: (state) => state.isLoading,
    error: (state) => state.error,
    hasData: (state) => Object.keys(state.sentimentData).length > 0
  }
};

console.log('✅ GM Sentiment Analytics Store: Module created successfully');

export default sentimentAnalytics;
